module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6rR2Jn/tc-custom/9781426885747.jpg?1728353525045",
      "alt": "This image is the cover for the book Hamilton Heir, Davis Landing"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hamilton Heir, Davis Landing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("The Davis Landing Observer")]), _vm._v(" Page 5"), _c('br'), _c('br'), _vm._v("The Gossip Guru"), _c('br'), _c('br'), _vm._v("hears tough tycoon Tim Hamilton—the "), _c('i', [_vm._v("legitimate")]), _vm._v(" son currently running Hamilton Media for his ailing father—was seen squiring his assistant, Dawn Leroux, around town last week. Inside information is that Tim wrecked Dawn's car and offered to lend her a replacement, but her concern was with the people on her meal-delivery route. Only time will tell if the lovely Ms. Leroux's sweet nature can tame Tim's all-business beast and turn him into a human being.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Valerie Hansen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Valerie Hansen resides in the rural Ozarks where she writes the books of her heart, primarily for Love Inspired Romance and Suspense. She is married to her childhood sweetheart and has worked as a teacher's-aide, EMT, fire dept. dispatcher, dog breeder, commercial artist, dulcimer builder, Veterinarian's asst., 4-H leader, Sunday School teacher, antique restorer and certified Storm Spotter, etc. See ValerieHansen.com for more!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0